import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  height:14%;
  padding:1% 3% 0;
  .rdsbottom{
    border-bottom-left-radius: 30px;
  }
`

export const DetailsWrapper = styled.div`
  padding: 2%;
  margin-top:-30px;
`

export const ListItem = styled.div`
  .bgf1{
    background-color:#f1f1f1;
  }
  .ga5{
    color:#a5a5a5;
  }
  box-shadow: 3px 3px 6px rgba(211,211,211,0.58);
  .list-top{
    height:36px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
  }
  .list-bottom{
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .textMsg{
      margin:5px auto 2px;
      color:#00d89e;
    }
    .dash{
      border-left:2px dashed #bdf6e7;
    }
    .foodList{
      height:65px;
      width:95%;
      box-shadow: 3px 3px 6px rgba(211,211,211,0.58);
      transition:width .5s ease;
      &.cancel{width:88%;}
      .foodItem{
        box-shadow: 2px 2px 3px rgba(211,211,211,0.58);
        img{ 
          width:46px;
          height:46px;
        }
      }
      .tips{
        color:red;
      }
      .g00d89e{color:#00d89e;}
      .gf15b6c{color:#f15b6c;}
      .g717ffa{color:#717ffa;}
      .infoOrder{
        right:10px;
        top:5px;
        line-height:1.2857rem;
      }
      .price{
        right:12px;
        bottom:9px;
      }
    }
    .clickDot{
      left:90%;
      opacity: 0;
      transition:opacity .8s ease;
      &.cancel{
        opacity: 1;
      }
    }
    .checkBox{
      clip: rect(0 0 0 0);    //做裁剪
    }
    .checkBox:checked + .labelBox>.yesBox{
      display:block;
    }
    .checkBox:checked + .labelBox{
      background-color:#f5004d;
      border:0;
    }
  }
`

export const Receipt = styled.div`
  .wMin80{
    min-Width:80%;
  }
  .wMin17{
    min-Width:17%;
  }
  height:130px;
  bottom:52px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  .telBox{
    color:#232323;
  }
  .orderMsg{
    padding:0 10px 0;
    color:#606060;
  }
  .g8a8a8a{
    color:#8a8a8a;
  }
  .patientNameBox{
    color:#232323;
    padding-right:34px;
  }
  .bedBox{
    color:#8a8a8a;
  }
  .bednumBox{
    color:#232323;
    padding-right:34px;
  }
  .bg72{
    background-color:#727272;
  }
  .gf3014d{
    color:#f3014d;
  }
  .g00d89e{
    color:#00d89e;
  }
  .bg00d89e{
    background-color:#00d89e;
  }
  .unsubscribe{
    color:#3887fc;
  }
  .unsubscribe:active{
    color:#9f9f9f;
  }
`
